import { render } from "./dangjInfo.vue?vue&type=template&id=07b5c690&scoped=true"
import script from "./dangjInfo.vue?vue&type=script&lang=js"
export * from "./dangjInfo.vue?vue&type=script&lang=js"

import "./dangjInfo.vue?vue&type=style&index=0&id=07b5c690&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b5c690"]])

export default __exports__